import axios from 'axios';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async provisionSkillformUser(_, { appType }) {
    const response = await axios.post('/api/students/skillform-provision/', { app_type: appType });
    return response.data;
  },
};

export const skillform = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
